import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import style from '../../style/components/signin/DataRights.module.scss';
import dataRightsIcon from '../../img/icons/book-open.svg';
import RemoveDataModal from './RemoveDataModal';
import RequestDataModal from './RequestDataModal';
import RequestDataButton from './RequestDataButton';
import { useDispatch } from 'react-redux';
import { fetchDataDownloadsStatus } from '../../actions/dataDownloads';
import Card from '../Card';

const DataRights = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [isRequestDataModalOpen, setIsRequestDataModalOpen] = useState(false);
  const [isRemoveDataModalOpen, setIsRemoveDataModalOpen] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchDataDownloadsStatus());
  }, [dispatch]);

  const accountLink = <Link to="/overview">wallet.id.me</Link>;
  const privacyBillLink = (
    <a href="https://network.id.me/privacy-bill-of-rights/">
      Privacy Bill of Rights
    </a>
  );
  const privacyPolicyLink = (
    <a href="https://www.id.me/privacy">Privacy Policy</a>
  );

  const choices = [
    {
      title: t('dataRights.updateProfile.heading'),
      description: (
        <>
          <p>{t('dataRights.updateProfile.description_address')}</p>
          <p>{t('dataRights.updateProfile.description_name')}</p>
          <p>{t('dataRights.updateProfile.description_timeline')}</p>
        </>
      ),
      button: (
        <idme-button
          variant="secondary"
          text={t('dataRights.updateProfile.button_update')}
          type="button"
          size="small"
          onClick={() => history.push('/profile')}
        />
      ),
    },
    {
      title: t('dataRights.download.heading'),
      description: (
        <>
          <p>{t('dataRights.download.description_rights')}</p>
          <p>{t('dataRights.download.description_frequency')}</p>
        </>
      ),
      button: (
        <RequestDataButton
          setIsRequestDataModalOpen={setIsRequestDataModalOpen}
        />
      ),
    },
    {
      title: t('dataRights.manage.heading'),
      description: (
        <>
          <p>{t('dataRights.manage.description_commitment')}</p>
          <p>
            <Trans
              i18nKey="dataRights.manage.description_closure"
              components={{ privacyLink: privacyPolicyLink }}
            />
          </p>
        </>
      ),
      button: (
        <idme-button
          variant="secondary"
          text={t('dataRights.manage.button_remove')}
          type="button"
          size="small"
          onClick={() => setIsRemoveDataModalOpen(true)}
        />
      ),
    },
  ];

  return (
    <Card
      title={t('dataRights.title')}
      icon={<img alt="" src={dataRightsIcon} />}
    >
      <p className={style.description}>
        <Trans
          i18nKey="dataRights.description_intro"
          components={{
            accountLink,
            privacyLink: privacyBillLink,
          }}
        />
      </p>
      <section className={style.choices}>
        {choices.map((choice) => {
          return (
            <div className={style.choice} key={choice.title}>
              <h4>{choice.title}</h4>
              <div className={style.description}>{choice.description}</div>

              {choice.button}
            </div>
          );
        })}
      </section>

      <RequestDataModal
        isOpen={isRequestDataModalOpen}
        closeModal={() => setIsRequestDataModalOpen(false)}
      />
      <RemoveDataModal
        isOpen={isRemoveDataModalOpen}
        closeModal={() => setIsRemoveDataModalOpen(false)}
      />
    </Card>
  );
};

export default DataRights;
